<template>
  <v-dialog content-class="comparison-dialog-content" lazy>
    <!-- The slot for the activator -->
    <template #activator="{on}">
      <slot name="activator" :on="on" />
    </template>
    <!-- The items to compare -->
    <v-container fluid>
      <!-- The title of the dialog -->
      <v-layout class="white--text display-1 text-xs-center">
        <v-flex xs6>Pivote</v-flex>
      </v-layout>
      <v-layout>
        <!-- The pivot one -->
        <v-flex xs6>
          <v-comparison-dialog-item :item="pivotItem" />
        </v-flex>
        <!-- The other item -->
        <v-flex xs6>
          <v-comparison-dialog-item :item="item" />
        </v-flex>
      </v-layout>
    </v-container>
  </v-dialog>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("matching");

import VComparisonDialogItem from "./ComparisonDialogItem";

/**
 * A component to show the pivot image and data with the given item in a side-by-side
 * comparison with a modal that covers a bigger space. Very useful to compare with
 * more details in mind the two items.
 */
export default {
  components: {
    VComparisonDialogItem
  },
  props: {
    item: {
      type: Object,
      required: true,
      // validator: val => !!val.image && !!val.brand && !!val.name
    }
  },
  computed: {
    ...mapGetters(["pivotItem"])
  }
};
</script>

<style>
.comparison-dialog-content {
  border-radius: 25px;
  background-color: rgba(0, 0, 0, 0.85);
}
</style>